import app from 'flarum/forum/app';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import { ANIMATED_TYPES } from '../utils/animatedTypes';
/**
 * An `AvatarEditor` that shows a crop modal before handing the resulting file
 * back to core's upload flow.
 */
export default class ProfileImageCropAvatarEditor extends AvatarEditor {
  upload(file) {
    if (!file || !window.FileReader || ANIMATED_TYPES.includes(file.type)) return super.upload(file);
    if (this.loading) return;
    app.modal.show(() => import(/* webpackChunkName: 'forum/components/ProfileImageCropModal', webpackMode: 'lazy-once' */ './ProfileImageCropModal'), {
      file,
      upload: croppedFile => {
        // Core's `upload()` fires the request but doesn't hand back a promise,
        // so we mirror its request here to know when the upload settles —
        // reusing its `success`/`failure` handlers to keep the store in sync.
        const user = this.attrs.user;
        const data = new FormData();
        data.append('avatar', croppedFile);
        this.loading = true;
        m.redraw();
        return app.request({
          method: 'POST',
          url: "".concat(app.forum.attribute('apiUrl'), "/users/").concat(user.id(), "/avatar"),
          serialize: raw => raw,
          body: data
        }).then(response => {
          this.success(response);
          app.modal.close();
        }).catch(error => {
          this.failure(error);

          // Rethrow so the modal surfaces the error and stays open.
          throw error;
        });
      }
    });
  }
}
flarum.reg.add('fof-profile-image-crop', 'forum/components/ProfileImageCropAvatarEditor', ProfileImageCropAvatarEditor);flarum.reg.addChunkModule('247', '820', 'fof-profile-image-crop', 'forum/components/ProfileImageCropModal');